import { getSpendingAccounts } from 'app-components/flux/accounts/accountsSelectors';
import { reportsSelectors } from 'app-components/flux/reports';
// import { List as ImmutableList } from 'immutable';
import { DateTime } from 'luxon';
import { createSelector } from 'reselect';

export const getConversationalCategoryData = createSelector(
  (state, props) =>
    reportsSelectors.getIncomeSpendingReportForDisplay(state, {
      reportName: 'all',
      timeStep: 'MONTHS',
      isOverTime: true,
      chartType: 'pie',
      groupBy: 'category',
      ...props,
    }),
  //  (state, props) =>
  //    reportsSelectors.getIncomeSpendingReportForDisplay(state, {
  //      reportName: 'all',
  //      timeStep: 'MONTHS',
  //      isOverTime: true,
  //      chartType: 'pie',
  //      groupBy: 'payee',
  //      ...props,
  //    }),
  (state) => getSpendingAccounts(state),
  (catChartData, payeeChartData /*, _spendingAccounts */) => {
    /*
     * DATA we want is located in chartData.rawReport.periods, which is an array of objects for each time period
     * each group object will contain the data for each separate group (defined by groupBy)
     *
      rawReport.periods[0].groups {
        Groceries: { isIgnored: false, txns: [ [Object], [Object] ], total: -30 },
        Education: { isIgnored: false, txns: [ [Object], [Object] ], total: -50 },
        Home: { isIgnored: false, txns: [ [Object] ], total: -30 },
        Uncategorized: { isIgnored: false, txns: [ [Object], [Object] ], total: -50 }
      }

     *
     * the overall totals for the full range are included in rawReport.allGroups
     *
      rawReport.allGroups {
        Home: { total: -60, isIgnored: false },
        Groceries: { total: -60, isIgnored: false },
        Education: { total: -100, isIgnored: false },
        Uncategorized: { total: -100, isIgnored: false }
      }
     */

    // console.log("CAT CHART DATA ", catChartData);

    if (!catChartData || !payeeChartData) return undefined;

    // console.log(catChartData);
    // const catChartDataJS = catChartData.toJS();
    // const payeeChartDataJS = payeeChartData.toJS();
    const catPeriods = catChartData.get('rawReport').toJS().periods;
    // const payeePeriods = payeeChartData.get('rawReport').toJS().periods;
    // const { payeePeriods } = payeeChartData.rawReport.toJS();
    // const { allGroups } = chartDataJS.rawReport;

    const catSpendTotal = {};
    const catIncomeTotal = {};
    // const payeeSpendTotal = {};
    // const payeeIncomeTotal = {};

    //
    // Construct PAYEE prompts
    //
    // Need to make it so that we only keep the top 10 payees per period, then put the rest in "Everything Else"
    //
    /*
    payeePeriods.forEach((period) => {
      if (period.txns.length > 0) {
        const dateTime = DateTime.fromISO(period.timeStamp);
        const dateString = dateTime.toFormat('MMMM, yyyy');
        promptList = promptList.push(`Payee data for ${dateString}: \n`);
        Object.entries(period.groups).forEach(([payeeName, payeeRecord]) => {
          promptList = promptList.push(`'${payeeName}': $${payeeRecord.total.toFixed(2)} \n`);
          if (payeeRecord.total > 0) {
            payeeIncomeTotal[payeeName] = payeeIncomeTotal[payeeName] ? payeeIncomeTotal[payeeName] + payeeRecord.total : payeeRecord.total;
          } else {
            payeeSpendTotal[payeeName] = payeeSpendTotal[payeeName] ? payeeSpendTotal[payeeName] + payeeRecord.total : payeeRecord.total;
          }
        });
      }
    });
    Object.entries(payeeSpendTotal).forEach(([payeeName, val]) => {
      promptList = promptList.push(`Total spending on payee '${payeeName}' $${val.toFixed(2)}\n`);
    });
    Object.entries(catIncomeTotal).forEach(([payeeName, val]) => {
      promptList = promptList.push(`Total Income from payee '${payeeName}' $${val.toFixed(2)}\n`);
    });
    */

    //
    // Construct CATEGORY prompts
    // and totals for the periods
    //
    const catJSON = {};
    catPeriods?.forEach((period) => {
      if (period.txns.length > 0) {
        const dateTime = DateTime.fromISO(period.timeStamp);
        const dateString = dateTime.toFormat('MMMM, yyyy');
        let periodSpendTotal = 0;
        let periodIncomeTotal = 0;
        catJSON[dateString] = [];
        Object.entries(period.groups).forEach(([catName, catRecord]) => {
          const txns = catRecord.txns.map((txn) => {
            return {
              date: DateTime.fromISO(txn.postedOn).toFormat('MM/dd/yyyy'),
              payee: txn.payee,
              amount: txn.amount,
              category: catName,
            };
          });
          catJSON[dateString].push({ transactions: txns, category: catName, periodAmount: catRecord.total.toFixed(2) });
          periodSpendTotal += catRecord.total < 0 ? catRecord.total : 0;
          periodIncomeTotal += catRecord.total > 0 ? catRecord.total : 0;
          if (catRecord.total > 0) {
            catIncomeTotal[catName] = catIncomeTotal[catName]
              ? catIncomeTotal[catName] + catRecord.total
              : catRecord.total;
          } else {
            catSpendTotal[catName] = catSpendTotal[catName]
              ? catSpendTotal[catName] + catRecord.total
              : catRecord.total;
          }
        });

        catJSON[dateString].totalIncome = periodIncomeTotal.toFixed(2);
        catJSON[dateString].totalExpense = periodSpendTotal.toFixed(2);
      }
    });

    catJSON.overallSpending = [];
    catJSON.overallIncome = [];
    Object.entries(catSpendTotal)?.forEach(([catName, val]) => {
      catJSON.overallSpending.push({ category: catName, periodAmount: val.toFixed(2) });
    });
    Object.entries(catIncomeTotal)?.forEach(([catName, val]) => {
      catJSON.overallIncome.push({ category: catName, periodAmount: val.toFixed(2) });
    });

    // console.log("JSON OBJECT IS ", JSON.stringify(catJSON));

    return {
      // promptList: promptList.reduce((r, i) => `${r}${i}`, ''),
      catJSON,
    };

    // return (promptList);
  },
);
